type JwtPayload = {
  exp?: number;
};

const decodeBase64Url = (value: string): string => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padding = normalized.length % 4;
  const padded = padding === 0 ? normalized : `${normalized}${"=".repeat(4 - padding)}`;
  return atob(padded);
};

export const parseJwtPayload = (token?: string | null): JwtPayload | null => {
  if (!token) {
    return null;
  }

  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) {
      return null;
    }

    return JSON.parse(decodeBase64Url(base64Url));
  } catch (_error) {
    return null;
  }
};

export const hasValidAccessToken = (token?: string | null): boolean => {
  const payload = parseJwtPayload(token);
  if (!token || !payload || typeof payload.exp !== "number") {
    return false;
  }

  return payload.exp * 1000 > Date.now();
};

export const hasValidStoredAccessToken = (): boolean => {
  return hasValidAccessToken(localStorage.getItem("accessToken"));
};
